import React from 'react';

import { Link as CoreLink } from 'core/components';

import LabelValue from 'app/views/metrics/components/LabelValue';
import isSafeExternalUrl from './isSafeExternalUrl';

const ServiceNowContextItem = ({ context, labelWidth = 150 }) => {
  const sn = context?.servicenow;

  if (!sn) {
    return null;
  }

  const { incident_id: incidentId, incident_url: incidentUrl } = sn;

  if (!incidentId) {
    return null;
  }

  return (
    <LabelValue
      label="ServiceNow Incident"
      labelWidth={labelWidth}
      value={
        isSafeExternalUrl(incidentUrl) ? (
          <CoreLink to={incidentUrl} blank rel="noopener noreferrer">
            {incidentId}
          </CoreLink>
        ) : (
          incidentId
        )
      }
    />
  );
};

export default ServiceNowContextItem;
